module.exports = __webpack_public_path__ + "img/Close_Line_18px_2_Icon_black.bed0d2ad.svg";